const getIsoTimeZoneOffset = (timeZoneOffsetInMinutes: number): string => {
  const hours = Math.abs(timeZoneOffsetInMinutes);
  const fullHours = Math.floor(hours / 60);
  const fullMinutes = Math.floor(hours % 60);

  let offsetPrefix = 'Z';

  if (timeZoneOffsetInMinutes > 0) {
    offsetPrefix = '+';
  } else if (timeZoneOffsetInMinutes < 0) {
    offsetPrefix = '-';
  }

  const offsetTime =
    timeZoneOffsetInMinutes !== 0
      ? `${fullHours.toString().padStart(2, '0')}:${fullMinutes.toString().padStart(2, '0')}`
      : '';

  const isoTimeZoneOffset = `${offsetPrefix}${offsetTime}`;

  return isoTimeZoneOffset;
};

const serializeIsoDateTime = (date: Date): string => {
  const dateTimeZoneOffset = date.getTimezoneOffset();
  const timeZoneOffsetInMinutes = -dateTimeZoneOffset;

  const utcAdjustedDate = new Date(date);
  utcAdjustedDate.setMinutes(utcAdjustedDate.getMinutes() + timeZoneOffsetInMinutes);

  const utcDateTime = utcAdjustedDate.toISOString();

  const isoTimeZoneOffset = getIsoTimeZoneOffset(timeZoneOffsetInMinutes);
  const isoDateTime = utcDateTime.replace('Z', isoTimeZoneOffset);

  return isoDateTime;
};

export default serializeIsoDateTime;
